import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ResellerList } from "../../Redux/Actions/resellerActions";
import { columnsReseller } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponentsCp";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";


const ListReseller = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const { resellerList, loading } = useSelector((state) => state.reseller);
  // const { admin } = useSelector((state) => state.admin || {});
  // const accessCode = admin?.data?.access_code || [];
  // const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');


  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleStatusChange = async (record, action) => {
    let payload = { id: record._id };

    if (action === "block") {
      payload.status = "BLOCK";
    } else if (action === "unblock") {
      payload.status = "UNBLOCK";
    } else {
      payload.status = action;
    }

    // await dispatch(blockUnblockMember(payload));
    fetchDetails(pagination.current, pagination.pageSize); // refresh list
  };

  const fetchDetails = useCallback(async (page, pageSize, role, showLoader = true) => {
    const teamData = {
      page,
      limit: pageSize,
      is_deleted: false,
      role: ["reseller"],
      filter: debouncedSearch,
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(ResellerList(teamData, showLoader));

      if (!showLoader) {
        toast.success("kiosk list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh kiosk list");
      }
    }
  },
    [dispatch, debouncedSearch, dateRange]
  )

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);


  useEffect(() => {
    if (resellerList?.total) {
      setPagination((prevData) => ({ ...prevData, total: resellerList.total }));
    }
  }, [resellerList]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponent
        h3heading="Reseller List"
        setState={setSearchQuery}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        dataSource={(Array.isArray(resellerList?.data) && resellerList.data) || []}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}
        columns={columnsReseller(handleStatusChange)}
      ></TableComponent>

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListReseller;
